"use strict";
/// <reference path="irep.js"/>

IREP.POWArchiveBand = (function () {

    var archiveInterationsRan = 0;
    var archiveIterationsToRun;
    var $Rows;
    var $i = 0;
    var timerPOWArchive;
    var tl = new TimelineMax({ paused: true });
    var $RowsToShow = 3;
    var init = function(options) {
        $Rows = $(".Row");
        archiveIterationsToRun = Math.ceil($Rows.length / $RowsToShow);
        
    };

    var tickerPOW = function () {
        $("#powBand").css("display", "block");
        $("#powArchiveBand").css("display", "none");
       // timerPOWArchive = window.setInterval(tickerPOWArchive, 5000); //The interval is already active, so we don't need this here. Calling it multiple times can cause multiple calls to the tickerPowArchive faster than 5 sec apart
    };

    var tickerPOWArchive = function () {

        animatePOWBand();
        if (archiveInterationsRan == archiveIterationsToRun) {
            archiveInterationsRan = 0;
            window.clearInterval(timerPOWArchive);
            for (var i = 0; i < $Rows.length; i++) {
                $Rows.eq(i).css("display", "none");
            }
            tickerPOW();
            return;
        }

        // set all the displayed items to display none
        $Rows.each(function (index) {
            if ($(this).css("display") == "block") {
                TweenMax.fromTo($(this), .25, { opacity: 1 }, { opacity: 0, overwrite: 2, onComplete: hideMe, onCompleteParams: [$(this)] });
            }
        });
        $("#powBand").css("display", "none");
        $("#powArchiveBand").css("display", "block");

        // starting with that item, begining changing display to block
        for (var j = 0; j < $RowsToShow; j++) {
            //TweenMax.fromTo($Rows.eq($i), 1.25, {marginTop:"0px" }, { marginTop:"-=500px", ease: Linear.easeNone, delay: 2.5, overwrite: 2 });

            tl.fromTo($Rows.eq($i), .35, { opacity: 0 }, { opacity: 1, onCompleteParams: [$Rows.eq($i)] });
            $Rows.eq($i).css("display", "block");
            // if we get to the last item, start over on the next pass
            $i++;
            if ($i == $Rows.length) {
                $i = 0;
                break;
            }
            
        }
        
        archiveInterationsRan++;
        tl.play();
    };

    var hideMe = function($me) {
        $me.css("display", "none");
    };

    var showMe = function($me) {
        $me.css("display", "block");
    };

    var animatePOWBand = function () {

        //TweenMax.fromTo($("#powBand"), 2, { opacity: 0 }, { opacity: 1 });
        //$("#powBand").css("display", "block");
    };

    var startAnimation = function () {
        animatePOWBand();
        $("#powBand").css("display", "block");
        $("#lnkDetails").attr("href", $("#lnkPostTitle").attr("href"));
        //timerPOWArchive = window.setInterval(tickerPOWArchive, 5000);
    };

    return {
        init: init,
        startAnimation: startAnimation
    };
})();